// extracted by css-extract-rspack-plugin
export default {"BannerDescription":"RepositoryMigratingNotice-module__BannerDescription__xAeF2"};